import React, { useState, useEffect, useRef } from "react";
import { useSignal, useSlot } from 'react-signal-slot'
import moment from "moment";
import { BaseComponent } from "../baseComponent/BaseComponent"
import { GetLotInfoPromise } from "./remote";
import { BaseLotInfoByUser } from "../../../Models/Lots/BaseLotInfoByUser"
import { PaymentStatus } from "../../../enums/PaymentStatus"
import { PaymentType } from "../../../enums/PaymentType"
import { TradeStatus } from "../../../enums/TradeStatus"
import { ApplicationStatus } from "../../../enums/ApplicationStatus"
import DepositLot from "../baseComponent/DepositLot"
import MakeBet from "../baseComponent/MakeBet"
import Tabs from "../baseComponent/tabs/tabs"
import { Menu } from "primereact/menu";
import AboutLotTab from "../baseComponent/tabs/AboutLotTab"
import AboutSellerTab from "../baseComponent/tabs/AboutSellerTab"
import { ApplicationDetails } from "../../../TradeApplication/components/ApplicationDetails";
import AccountInfo from "../../../Profile/AccountInfo"

interface IPropsType {
    lotId: number;
}

export class OpenAuctionWithApplications extends BaseComponent {
    constructor(props: IPropsType) {
        super(props);
        console.log(props);
        console.log("OpenAuctionWithApplication component loaded");

        this.state = {
            Lot: null,
            lotId: props.lotId
        }

        //useSlot('makeBet', this.AddNewBet);
    }

    getAuctionData() {
        GetLotInfoPromise(this.state.lotId).then((result) => {
            console.log(result);
            var paymentByDeposit = this.getPayment(result.Payments, PaymentType.PaymentOfDeposit);

            if (paymentByDeposit == null)
                result.DepositStatus = PaymentStatus.PaymentNotReceived;
            else
                result.DepositStatus = paymentByDeposit.StatusId;

            this.setState({ ...this.state, Lot: result });
            this.init(this.state);
            console.log('получили состояние', this.state);
        });
    }

    MenuTabs() {
        var array = [];

        array.push({
            Name: "AboutLot",
            Text: "О лоте",
            Data: <AboutLotTab lot={this.state.Lot} />,
            isActive: true
        });

        array.push({
            Name: "AboutSeller",
            Text: "О продавце",
            Data: <AboutSellerTab lot={this.state.Lot} />
        });

        array.push({
            Name: "AboutTrade",
            Text: "О торгах",
            Data: this.AboutTradeTab()
        });

        array.push({
            Name: "Requisits",
            Text: "Реквизиты",
            Data: this.Requisits()
        });

        array.push({
            Name: "Bets",
            Text: "Ставки",
            Data: this.Bets()
        });

        array.push({
            Name: "AboutContact",
            Text: "Контакты",
            Data: this.ContactInfo()
        });

        return array;
    }

    Requisits() {
        return (
            <div className="requisits detailsWrapper">
                <div className="requisitsInfo extendInfo">
                    <label className="infoItem">
                        <span className="defaultDataName">Получатель</span>
                        <p className="defaultDataValue">{this.state.Lot?.CompanyName}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">ИНН</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.INN}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">КПП</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.KPP}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">Наименование банка получателя</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.BankName}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">Расчетный счет</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.Giro}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">Лицевой счет</span>
                        <p></p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">БИК</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.BIK}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">Корреспондентский счет (ЕКС)</span>
                        <p className="defaultDataValue">{this.state.Lot?.BankRequisites?.[0]?.CorrespondentAccount}</p>
                    </label>

                    <label className="infoItem">
                        <span className="defaultDataName">Назначение платежа</span>
                        <p></p>
                    </label>
                </div>
            </div>
        )
    }

    AboutTradeTab() {
        return (
            <div className="aboutTrade detailsWrapper">
                <div className="tradeInfo">
                    <div className="infoItem">
                        <span className="defaultDataName">Вид торгов:</span>
                        <p className="defaultDataValue">{this.state.Lot.TradeTypeDescription}</p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Статус:</span>
                        <p className="defaultDataValue">{this.state.Lot.LotTradeStatusDescription}</p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Начало приема заявок:</span>
                        <p className="defaultDataValue">
                            {this.GetDate(this.state.Lot.LotApplicationPeriodStart)}
                        </p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Окончание приема заявок:</span>
                        <p className="defaultDataValue">
                            {this.GetDate(this.state.Lot.LotApplicationPeriodEnd)}
                        </p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Начало аукциона:</span>
                        <p className="defaultDataValue">
                            {this.GetDate(this.state.Lot.LotTradePeriodStart)}
                        </p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">НДС:</span>
                        <input className="defaultDataValue" />
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Шаг аукциона: {this.state.Lot?.StepInfo}</span>
                        <input className="defaultDataValue" />
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Размер задатка:</span>
                        <p className="defaultDataValue">{this.state.Lot?.DepositSize || this.state.Lot.BasePrice * (this.state.Lot?.DepositPercent / 100)} ₽</p>
                    </div>

                    <div className="infoItem">
                        <span className="defaultDataName">Порядок внесения и возврата задатка:</span>
                        <p className="defaultDataValue">{this.state.Lot?.DepositRules}</p>
                    </div>
                </div>

                {this.Documents()}
                {this.WinnerProtocolSection()}
            </div>
        );
    }

    // данный метод возвращает набор статусов при которых можно вносить задаток
    StatusesForDeposit() {
        return [TradeStatus.Approved, TradeStatus.AllowAcceptance, TradeStatus.WaitingForStartAllowAcceptance];
    }

    Buttons() {
        /* если аукцион не состоялся. Выведем причину по которой он не состоялся. */
        if (this.state.Lot.LotTradeStatusId == TradeStatus.TradeAbandoned)
            return (
                <div className="infoItem">
                    <span>Причина несостоявшихся торгов:</span>
                    <h5>{this.state.Lot.FailedTradeReasonText || "Неизвестная причина"}</h5>
                </div>
            );
        /* если аукцион имеет статус Идёт торг, то вносить задаток уже поздно. Так же если аукцион имеет статус Обработка заявок, то вносить задаток уже тоже поздно. */
        else if (this.state.Lot.LotTradeStatusId == TradeStatus.Trading)
            /* если заявка на участие в торгах была одобрена организатором */
            if (this.state.Lot.Application && this.state.Lot.Application.StatusId == ApplicationStatus.Approved) {
                return (
                    <MakeBet lotId={this.props.lotId} StepInfo={this.state.Lot.StepInfo} MinimumBet={this.calculateStep(this.state.Lot)} CompanyId={this.state.Lot.Bets?.at(-1)?.CompanyId} />
                );
            }
       /*  если статус лота - Обработка заявок. При этом статусе не доступны никакие кнопки (задаток, ставка, подать заявку) */
       else if (this.state.Lot.LotTradeStatusId == TradeStatus.ApplicationProcessing)
              return ('');

        // кнопка "Внести задаток" может быть доступна только при некоторых статусах для этого вида аукциона с приёмом заявок
        if (this.StatusesForDeposit().includes(this.state.Lot.LotTradeStatusId)) {

            /* если платёж по задатку ещё не поступал, т.е. даже чек не подгружали */
            if (this.state.Lot.DepositStatus == PaymentStatus.PaymentNotReceived)
                return (
                    <DepositLot lotId={this.props.lotId} CurrentCompanyId={AccountInfo.CompanyId} />
                );
            /* если платёж по задатку уже поступал, т.е. чек ранее подгружали */
            else if (this.state.Lot.DepositStatus == PaymentStatus.WaitingConfirm)
                return (
                    <p>Ваш платёж ожидает подтверждения. После подтверждения оплаты задатка вам станет доступна кнопка "Подать заявку" на участие в торгах.</p>
                );
            /* если платёж по задатку подтверждён администратором */
            else if (this.state.Lot.DepositStatus == PaymentStatus.Paid) {
                /* если идёт приём заявок */
                if (this.state.Lot.LotTradeStatusId == TradeStatus.AllowAcceptance) {
                    return (
                        <ApplicationDetails lotId={this.props.lotId} loadApp={true}></ApplicationDetails>
                    );
                }
                else {
                    return (<div className="infoItem">Вы допущены к подаче заявок. Когда начнётся приём заявок, вы сможете подать заявку</div>);
                }
            }
            }
    }

    render() {
        console.log('this.state.Lot=', this.state.Lot);
        if (this.state.Lot == null) {
            this.getAuctionData();
            return (<div>Загружаю данные...</div>);
        }
        else { 
            return (
                <div className="lotPage">
                    <div className="lotHead">
                        <h1>{this.state.Lot.Name}
                            <span>к/н {this.getCadastrNumber(this.state.Lot.Filters)}</span>
                        </h1>
                        <div className="middle">
                            {this.getGallery(this.props.lotId, this.state.Lot.Pictures, this.state.Lot.IsHasFavorites)}
                            <div className="lotActionMenu">
                                <div className="title">
                                    <h4>{this.state.Lot.CurrentPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h4>
                                    <span>Текущая цена</span>
                                        {this.Buttons()}
                                    { /* краткая информация по лоту */}
                                    <div className="shortInfo">

                                        {this.ShortInfoLot(this.state.Lot)}

                                        <div className="infoItem">
                                            <span>Размер задатка:</span>
                                            <h5>{this.state.Lot.DepositSize
                                                ? <>{this.state.Lot?.DepositSize || this.state.Lot.BasePrice * (this.state.Lot?.DepositPercent / 100)}₽ <p className="defaultDescription">Дата до которой необходимо внести задаток: {this.state.Lot?.DepositDate}</p></>
                                                : 'Сумма не найдена, обратитесь в тех.поддержку'}
                                            </h5>
                                            {this.state.Lot.DepositStatus == PaymentStatus.Paid && 
                                                <h5>Задаток оплачен</h5>
                                             }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        { this.ContactButtons() }
                    </div>

                    <div className="lotDetails">
                        {/* вкладки */}
                        <Tabs menu={this.MenuTabs()} />
                    </div>
                </div>
            );
        }
    }
}